module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Green.0a71e625.png";